import React from 'react'

import FilterSelect from 'components/common/FilterSelect'
import Flex from 'components/common/Flex'
import Text from 'components/common/Text'
import theme from 'theme'

export const THIS_WEEK = 0
export const THIS_MONTH = 1

const DashboardCardHeader: React.FC<{
  defaultFilter?: string
  extraText?: React.ReactNode
  filters: { value: string; label: string }[]
  hideFilter: boolean
  selectedFilter: string
  setSelectedFilter(value: string): void
  title: string
}> = ({
  title,
  selectedFilter,
  filters,
  setSelectedFilter,
  hideFilter,
  extraText = null
}) => (
  <div
    css={{
      backgroundColor: theme.colors.gray[0],
      display: 'flex',
      height: 48,
      borderTopLeftRadius: theme.borderRadius[0],
      borderTopRightRadius: theme.borderRadius[0]
    }}
    data-testid="dashboard-card-header"
  >
    <Flex
      css={{
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
        paddingLeft: theme.space[3],
        paddingRight: theme.space[3]
      }}
    >
      <Text
        as="h4"
        css={{
          color: theme.colors.steel[2],
          flex: 2
        }}
      >
        {title}
      </Text>
      {extraText}
      <div
        css={{
          display: 'flex',
          justifyContent: 'flex-end',
          flex: '1'
        }}
      >
        {!hideFilter && (
          <FilterSelect
            hideLabel
            css={{
              display: 'flex',
              justifyContent: 'flex-end',
              flex: '1'
            }}
            data-testid="dropdown"
            items={filters}
            name="FILTER"
            selectedValue={selectedFilter}
            textColor={theme.colors.blue[0]}
            onSelected={(value) => {
              setSelectedFilter(value)
            }}
          />
        )}
      </div>
    </Flex>
  </div>
)
export default DashboardCardHeader
